/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Recipe_Shopping_BodyInputs */

const en_recipe_shopping_body = /** @type {(inputs: Recipe_Shopping_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ingredients of “${i?.title}” go on the shopping list without planning a day.`)
};

const de_recipe_shopping_body = /** @type {(inputs: Recipe_Shopping_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Zutaten von „${i?.title}“ kommen auf die Einkaufsliste, ohne dass du einen Tag einplanst.`)
};

/**
* | output |
* | --- |
* | "The ingredients of “{title}” go on the shopping list without planning a day." |
*
* @param {Recipe_Shopping_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_body = /** @type {((inputs: Recipe_Shopping_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_body(inputs)
	return en_recipe_shopping_body(inputs)
});